import { useEffect, useRef, useState } from 'react';

// "Columns ▾" button + dropdown panel for showing/hiding table columns.
// The panel stays open while toggling; clicking outside closes it.
export default function ColumnToggle({ columns, visibility, onVisibilityChange }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    function handlePointerDown(e) {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handlePointerDown);
    return () => document.removeEventListener('mousedown', handlePointerDown);
  }, [open]);

  return (
    <div className="column-toggle" ref={rootRef}>
      <button
        type="button"
        className="btn btn--secondary"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="true"
        aria-expanded={open}
      >
        Columns ▾
      </button>
      {open && (
        <div className="column-toggle__panel" role="group" aria-label="Show or hide columns">
          <div className="column-toggle__title">Show/Hide Columns</div>
          {columns.map((c) => (
            <label key={c.key} className="column-toggle__option">
              <input
                type="checkbox"
                checked={visibility[c.key] !== false}
                onChange={(e) => onVisibilityChange(c.key, e.target.checked)}
              />
              {c.label}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
